

define(['angular', 'squid/module', 'text!./template.html', 'xo-page-components/src/value-props/directive', 'xo-guest-components/src/guest/directive'], function (angular, module, template) {

    return angular.module('hermes.page.xo-signup.directive', ['squid', 'xo-value-props.directive', 'xo-onboard.payment.directive']).directive('xoSignup', function ($rootScope, $SingleStepModel) {

        return {
            template: template,

            scope: {
                token: '=?',
                parentCallbacks: '=?',
                buttonParams: '=?'
            },

            controller: function controller($scope, $rootScope, $state, $locale) {
                // eslint-disable-line no-shadow
                $scope.mode = 'signup';
                $rootScope.mode = 'signup';
                $scope.backUri = 'checkout.signup';
                $scope.singleStepModel = new $SingleStepModel();

                $scope.onComplete = function () {
                    $state.go('checkout.end');
                };
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-signup/directive.js
// module id = ./pages/xo-signup/directive.js
// module chunks = 0